import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Gift, ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n";
import api from "@/api";

export function PromoBanner() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api.get("/promo/free-credit").then((r) => setPromo(r.data)).catch(() => {});
  }, []);

  if (!promo || !promo.active) return null;

  return (
    <motion.button
      type="button"
      data-testid="promo-banner"
      onClick={() => nav("/register")}
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="group relative w-full overflow-hidden bg-[#C65338] text-white text-left"
    >
      <div className="absolute inset-0 hero-grain opacity-40" />
      <div
        className="absolute inset-y-0 -left-1/3 w-1/3 skew-x-12 bg-white/15 blur-md"
        style={{ animation: "promoShine 3.5s linear infinite" }}
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-center gap-3 flex-wrap text-center">
        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/20 shrink-0">
          <Gift className="w-4 h-4" />
        </span>
        <span className="text-sm sm:text-base font-bold tracking-tight">
          {t("promo.headline")}
        </span>
        <span
          data-testid="promo-remaining"
          className="inline-flex items-center gap-1 rounded-full bg-[#E69625] px-3 py-1 text-xs sm:text-sm font-black tabular-nums shadow-sm"
        >
          {t("promo.only")} {promo.remaining} / {promo.limit}
        </span>
        <span className="inline-flex items-center gap-1 text-xs sm:text-sm font-semibold underline decoration-white/50 underline-offset-2 group-hover:decoration-white transition-all">
          {t("promo.cta")}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
        </span>
      </div>
    </motion.button>
  );
}
